var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCompletion = function SvgCompletion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M68.406 10a2 2 0 0 1 2 2v56a2 2 0 0 1-2 2H30.01a2 2 0 0 1-2-2V50.422l-.003-.07v-4.247a1 1 0 0 1 2-.017h.003V68h38.396V12H30.01v22.441H30a1 1 0 0 1-1.985 0h-.005v-.053l-.003-.07V30.07q0-.036.003-.07V12a2 2 0 0 1 2-2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M40.707 40.707a1 1 0 0 0 0-1.414l-6.364-6.364a1 1 0 1 0-1.414 1.414L37.586 39H11a1 1 0 1 0 0 2h26.586l-4.657 4.657a1 1 0 0 0 1.414 1.414z"
  })));
};
export default SvgCompletion;